import { UseFormReturn } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  FormDescription,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { TenantFormData } from "@/lib/schemas/tenant";

interface Step2ContactBillingProps {
  form: UseFormReturn<TenantFormData>;
}

export function Step2ContactBilling({ form }: Step2ContactBillingProps) {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h2 className="text-xl font-semibold">Contact & Billing</h2>
        <p className="text-sm text-muted-foreground">
          Set up billing preferences for this customer
        </p>
      </div>

      <FormField
        control={form.control}
        name="billing_email"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Billing Email *</FormLabel>
            <FormControl>
              <Input
                type="email"
                placeholder="billing@acme.com"
                {...field}
              />
            </FormControl>
            <FormDescription>
              Invoices and billing notifications will be sent here
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="billing_via_agency"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
            <div className="space-y-0.5">
              <FormLabel className="text-base">Bill Through Agency</FormLabel>
              <FormDescription>
                When enabled, usage charges are consolidated on your agency invoice
              </FormDescription>
            </div>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
}
